// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';

import ProductProvider from 'Contexts/ProductContext';
import ProductsProvider from 'Contexts/ProductsContext';
import ProductContainer from 'Containers/Product/ProductContainer';
import ViewProduct from 'Components/Product/ViewProduct';
import ProductQuickViewModal from 'Containers/Products/ProductQuickViewModal';
import ProductPicturesModal from 'Containers/Products/ProductPicturesModal';

const ProductPage = memo(() => {
  const { bodyAttributes } = Helmet.peek() || {};

  let productPageClassNames = bodyAttributes?.class || '';
  if (!productPageClassNames.includes('ProductPage')) {
    productPageClassNames += 'ProductPage';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <body className={ productPageClassNames } />
      </Helmet>
      <ProductsProvider>
        <ProductProvider>
          <ProductQuickViewModal />
          <ProductPicturesModal />
          <ViewProduct>
            <ProductContainer />
          </ViewProduct>
        </ProductProvider>
      </ProductsProvider>
    </>
  );
});
ProductPage.displayName = 'ProductPage';

export default ProductPage;
